var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.6504C22.164 10.6504 22.5 10.3144 22.5 9.90039V7.65039C22.5 6.40989 21.4905 5.40039 20.25 5.40039H15.75V7.65039C15.75 8.06439 15.414 8.40039 15 8.40039C14.586 8.40039 14.25 8.06439 14.25 7.65039V5.40039H3.75C2.5095 5.40039 1.5 6.40989 1.5 7.65039V9.90039C1.5 10.3144 1.836 10.6504 2.25 10.6504C3.4905 10.6504 4.5 11.6599 4.5 12.9004C4.5 14.1409 3.4905 15.1504 2.25 15.1504C1.836 15.1504 1.5 15.4864 1.5 15.9004V18.1504C1.5 19.3909 2.5095 20.4004 3.75 20.4004H14.25V18.1504C14.25 17.7364 14.586 17.4004 15 17.4004C15.414 17.4004 15.75 17.7364 15.75 18.1504V20.4004H20.25C21.4905 20.4004 22.5 19.3909 22.5 18.1504V15.9004C22.5 15.4864 22.164 15.1504 21.75 15.1504C20.5095 15.1504 19.5 14.1409 19.5 12.9004C19.5 11.6599 20.5095 10.6504 21.75 10.6504ZM15.75 15.1504C15.75 15.5644 15.414 15.9004 15 15.9004C14.586 15.9004 14.25 15.5644 14.25 15.1504V14.4004C14.25 13.9864 14.586 13.6504 15 13.6504C15.414 13.6504 15.75 13.9864 15.75 14.4004V15.1504ZM15.75 11.4004C15.75 11.8144 15.414 12.1504 15 12.1504C14.586 12.1504 14.25 11.8144 14.25 11.4004V10.6504C14.25 10.2364 14.586 9.90039 15 9.90039C15.414 9.90039 15.75 10.2364 15.75 10.6504V11.4004Z",
    fill: "#16AA40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/Coupon.a74d064ca87bc50eb698e34f88f11731.svg";
export { ForwardRef as ReactComponent };